import { Checkbox, FormControlLabel } from "@mui/material";
import "./checkboxCustom.css"; // import CSS

const CustomCheckbox = ({ label, checked, onChange ,customClass="custom-checkbox" }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          className={customClass}
        />
      }
      label={label}
      className="custom-checkbox-label"
    />
  );
};

export default CustomCheckbox;
